import { graphql } from 'react-relay';

export const AttachmentFragment = graphql`
    fragment AttachmentFragment on Attachment {
        id
        name
        extension
        url
        order
        created_by
    }
`;
